import { render, staticRenderFns } from "./VolumeDocuments.vue?vue&type=template&id=8b485366&scoped=true"
import script from "./VolumeDocuments.vue?vue&type=script&lang=js"
export * from "./VolumeDocuments.vue?vue&type=script&lang=js"
import style0 from "./VolumeDocuments.vue?vue&type=style&index=0&id=8b485366&prod&lang=scss"
import style1 from "./VolumeDocuments.vue?vue&type=style&index=1&id=8b485366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b485366",
  null
  
)

export default component.exports